module.exports = __webpack_public_path__ + "files/82408f3b57c354a6c16d63640f6f7350.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-5.png
// module id = 516
// module chunks = 76